import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RequestStatusEnum} from '@dto/requests/request-status.enum';
import {RequestListComponent} from '../request-list/request-list.component';

@Component({
    selector: 'app-in-progress-requests',
    templateUrl: './in-progress-requests.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RequestListComponent]
})
export class InProgressRequestsComponent {
  requestStatus = RequestStatusEnum.InProgress;
  noRequestsMessage = 'No requests in progress';
}
